var _style, _rect, _rect2, _polygon, _polygon2, _polygon3, _polygon4, _g, _g2, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnollarsvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1090 1080",
    style: {
      enableBackground: "new 0 0 1090 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;fill:#121633;}\r\n\t.st1{display:none;fill:url(#SVGID_1_);}\r\n\t.st2{display:none;fill:#292D7D;}\r\n\t.st3{fill:#FFFFFF;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;fill:#292D7D;}\r\n\t.st6{display:inline;fill:none;stroke:#121633;stroke-width:16;stroke-miterlimit:10;}\r\n\t.st7{display:inline;opacity:0.32;}\r\n\t.st8{display:inline;opacity:0.26;}\r\n\t.st9{fill:#121633;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -415,
    className: "st0",
    width: 1920,
    height: 1080
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 545,
    cy: 540,
    r: 2112.3408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 4.102398e-7,
    style: {
      stopColor: "#121633"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3687,
    style: {
      stopColor: "#141835"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5057,
    style: {
      stopColor: "#1B1F3B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.604,
    style: {
      stopColor: "#272A45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6839,
    style: {
      stopColor: "#383B53"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7526,
    style: {
      stopColor: "#4E5167"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8135,
    style: {
      stopColor: "#696C7E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8688,
    style: {
      stopColor: "#8A8C9A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9196,
    style: {
      stopColor: "#B0B1BB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9649,
    style: {
      stopColor: "#D9DADF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -415,
    className: "st1",
    width: 1920,
    height: 1080
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1708.17,1516.59 1708.17,1804.33 1634.54,1851.89 1634.54,1468.35  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "536,504 535.75,402.09 439.27,354.41 221.54,484.24 221.54,892.61 461.89,893 666,893 775,786  775.39,557.89 701,600 700.97,740 634,803.07 463.58,802.45 298,803 298,535 439,446  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "267.77,466 267.77,148.19 591.23,146 819.23,293 822.23,554 583.5,684.14 484.23,629.7 484.23,539.99  585.23,595 739.14,509.06 739,344 559,229.05 341.4,232 341.23,427  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "582.23,540 581.98,450.09 485.5,395.41 267.77,525.24 267.77,933.61 508.12,934 668.23,934  821.23,838 821.62,598.89 747.23,641 747,777 629,851 346.23,853 344.23,576 485.23,487  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "991.04,1673.5 991.04,1355.69 1314.5,1353.5 1542.5,1500.5 1545.43,1757.36 1306.77,1891.64  1207.68,1834.2 1207.68,1744.49 1305.49,1802.15 1462.41,1716.56 1462.41,1533.76 1311.77,1436.55 1064.67,1439.5 1064.5,1634.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "1305.5,1752.5 1305.25,1650.59 1208.77,1602.91 991.04,1732.74 991.04,2141.11 1231.39,2141.5  1435.5,2141.5 1544.5,2034.5 1544.89,1806.39 1470.5,1848.5 1470.47,1988.5 1403.5,2051.57 1233.08,2050.95 1067.5,2051.5  1067.5,1783.5 1208.5,1694.5  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "309.54,1497.35 309.54,1259.19 541.42,1257 775,1397.49 775,1659.84 536.35,1794.12 438.18,1737.7  438.18,1647.99 535.99,1705.65 692.91,1620.06 692.91,1437.26 542.27,1340.05 383.17,1343 383.17,1545.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "383.17,1545.59 383.17,1833.33 309.54,1880.89 309.54,1497.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "346.69,1856.75 346.35,1299 544.46,1299 731.46,1418 731.44,1638.85 678.46,1671  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "609.46,1707 536.35,1747.86 480.49,1714 480.49,1708.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "438.18,1733.47 438.18,1647.09 534.65,1588.41 778.39,1718.24 778.39,1985.61 538.04,2127  309.54,2126.44 309.54,1880.89 384.01,1832.49 384.01,2038 536.35,2036.45 702.22,1943.35 702.22,1760.55 534.65,1675.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "480.46,1714 481.49,1669.3 537.35,1633.76 738.46,1739 737.77,1962.51 536.35,2079.3 346.77,2079  346.69,1849.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "604.29,1711.34 563.19,1690.82 552.89,1696.43 627.6,1742.78 646.23,1732.29 604.29,1711.34  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "692.54,1437 693.46,1620 775.46,1660 774.46,1397.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "702.46,1761 702.46,1943 778.46,1986 780.46,1716.8  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-2159.46,345.35 -2159.46,107.19 -1927.58,105 -1694,245.49 -1694,507.84 -1932.65,642.12  -2030.82,585.7 -2030.82,495.99 -1933.01,553.65 -1776.09,468.06 -1776.09,285.26 -1926.73,188.05 -2085.83,191 -2085.83,393.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-2085.83,393.59 -2085.83,681.33 -2159.46,728.89 -2159.46,345.35  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "-2122.31,704.75 -2122.65,147 -1924.54,147 -1737.54,266 -1737.56,486.85 -1790.54,519  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "-1859.54,555 -1932.65,595.86 -1988.51,562 -1988.51,556.25  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "-2030.82,581.47 -2030.82,495.09 -1934.35,436.41 -1690.61,566.24 -1690.61,833.61 -1930.96,975  -2159.46,840.44 -2159.46,728.89 -2084.99,680.49 -2084.99,793.04 -1932.65,884.45 -1766.78,791.35 -1766.78,608.55  -1934.35,523.98  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "-1988.54,562 -1987.51,517.3 -1931.65,481.76 -1730.54,587 -1731.23,810.51 -1932.65,927.3  -2122.23,813.89 -2122.31,697.75  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st7",
    points: "-1864.71,559.34 -1905.81,538.82 -1916.11,544.43 -1841.4,590.78 -1822.77,580.29 -1864.71,559.34  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "-1776.46,285 -1775.54,468 -1693.54,508 -1694.54,245.8  "
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "-1766.54,609 -1766.54,791 -1690.54,834 -1688.54,564.8  "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnollarsvg);
export default __webpack_public_path__ + "static/media/bnollarsvg.56fbe0c454a9780b2d118aa5798b7897.svg";
export { ForwardRef as ReactComponent };